import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.pruefplan-rollen-pruefer-hinzufuegen';
import * as api from '../../../clients/qschecks';

@Injectable()
export class QschecksPruefplanRollenPrueferHinzufuegenEffects {

    PruefplanRollenPrueferHinzufuegen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_PRUEFPLAN_ROLLEN_PRUEFER_HINZUFUEGEN),
        mergeMap((x: ac.PostPruefplanRollenPrueferHinzufuegenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postPruefplanRollenPrueferHinzufuegen(x.pruefplanRolleMultiRequest).pipe(
                map((result: any) => {
                    return new ac.PostPruefplanRollenPrueferHinzufuegenErfolgreichAction(result, x.pruefplanRolleMultiRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostPruefplanRollenPrueferHinzufuegenFehlerAction(error, x.pruefplanRolleMultiRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.AdminCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.AdminCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.AdminCommandService);
        }
        return this.service;
    }
}
